import React, { useState, memo, useEffect, useCallback } from 'react';
import Table from "components/Table";

import { CTeStockItemsProps } from './interface';

import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';

import { IBatchRequestResponse } from 'models/Batch';
import { CTeStockItem } from 'models/CTEs';
import { checkLabelExpirationDay } from '../utils';

import CteServices from 'services/cte.service';

const CTeStockItems: React.FC<CTeStockItemsProps> = (props) => {

  const { model, cteStock } = props;

  const pageSize = 5;

  const [cteStockItem, setCteStockItems] = useState<IBatchRequestResponse<CTeStockItem>>();
  const [tableItemOrderBy, setTableItemOrderBy] = useState("");
  const [currentPageItem, setCurrentPageItem] = useState(0);

  const cteService = new CteServices();

  useEffect(() => {
    getCTeStockItems();
  }, [currentPageItem, tableItemOrderBy]);

  const getCTeStockItems = useCallback(() => {
    setCteStockItems(undefined);

    cteService
      .getStockItemsCTe(currentPageItem, pageSize, tableItemOrderBy, cteStock?.id)
      .then((result: IBatchRequestResponse<CTeStockItem> | undefined) => {

        if (result) {
          const { error, data, totalPages, pageSize, total } = result;

          data?.forEach((item: any) => {
            item.daysToExpireLabel = checkLabelExpirationDay(item);
          });

          setCteStockItems({ error, data, totalPages, pageSize, total });
        }
      });

  }, [currentPageItem, tableItemOrderBy]);

  return (
    <Column className="animated fadeIn px-md-2 px-3 py-2 bg-white overflow-x-auto">

      <Row id="info-table-cte-items" >
        <Row className="payment-breakpoint">
          <Text className="d-block font-bold color-blue-gray mt-2 mb-1" size={12}>
            
          </Text>
        </Row>
      </Row>

      <Table
        trackingKey="Visualizar Itens Stock CTe"
        setTableOrder={setTableItemOrderBy}
        tableOrder={tableItemOrderBy}
        error={cteStockItem?.error || false}
        onReload={getCTeStockItems}
        currentPage={currentPageItem}
        data={cteStockItem?.data}
        pageSize={pageSize}
        onPageChange={setCurrentPageItem}
        totalPages={cteStockItem?.totalPages}
        model={model}
        completeBlankSpaces={false}
        rowHeight={40}
        customProps={{ cteStockId: cteStock.id }}
        className="mb-1"
      />
    </Column>
  );
};

export default memo(CTeStockItems);
